// T36 (Titipan auditor 27 Okt 2026, masukan Owner 24 Okt): layar Buat WO memilih FA dari DAFTAR FA berjalan di
// wilayah/cabang pengguna (GET /wo/calon-fa), bukan mengetik nomor. Teks pilihan: "nomor · tim · keadaan · cabang ·
// tenggat". Nama tim hanya datang dari server untuk peran yang boleh membacanya.
import { FA_STATUS_LABEL } from "./statusLabels";

export const PESAN_PILIH_DULU = "Pilih pesanan dulu dari daftar, lalu klik Tambah.";

function tanggalPendek(iso) {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short" });
}

/** Keterangan kecil di bawah nomor FA pada daftar pilihan. */
export function keteranganCalonFa(f) {
  if (!f) return "";
  const bagian = [];
  if (f.nama_team) bagian.push(f.nama_team);
  if (f.order_status) bagian.push(FA_STATUS_LABEL[f.order_status] || f.order_status);
  if (f.store_name) bagian.push(`Cabang ${f.store_name}`);
  const t = tanggalPendek(f.deadline_date);
  if (t) bagian.push(`tenggat ${t}`);
  return bagian.join(" · ");
}

/** Buang FA yang sudah ada di daftar terpilih — tidak ditawarkan dua kali. */
export function calonBelumDipilih(items, terpilih) {
  const ada = new Set((terpilih || []).map((x) => x.id));
  return (items || []).filter((f) => f && !ada.has(f.id));
}
